/**
 * Redux listener middleware.
 * For cross-slice side effects that don't belong in a reducer (e.g. "refetch the
 * current user after joining an org"). Register new effects here; each feature's
 * listeners can live in their own file and be added to `listenerMiddleware` via
 * `startAppListening` from wherever the app is composed (see `store.ts`).
 */

import { createListenerMiddleware, addListener } from '@reduxjs/toolkit';
import type { TypedStartListening, TypedAddListener } from '@reduxjs/toolkit';
import type { RootState, AppDispatch } from '../stores/store';

export const listenerMiddleware = createListenerMiddleware();

export const startAppListening = listenerMiddleware.startListening as TypedStartListening<RootState, AppDispatch>;
export const addAppListener = addListener as TypedAddListener<RootState, AppDispatch>;
